<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<ng-container *ngIf="ready">

  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap"><mat-icon>account_balance_wallet</mat-icon></div>
      <div>
        <span>{{tittle}}</span>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dlg-body">

    <ng-container *ngIf="saved === false">
      <div class="row">
        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="Fecha" placeholder="" name="movimientoEfectivo.fecha" required
              [(ngModel)]="movimientoEfectivo.fecha" />
            <mat-datepicker-toggle matSuffix [for]="Fecha"></mat-datepicker-toggle>
            <mat-datepicker #Fecha></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-4">
          <app-input inputType="text" placeholder="Concepto" [isRequired]="true"
            [(ngModel)]="movimientoEfectivo.concepto"></app-input>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <mat-label>Importe</mat-label>
            <input type="text" matInput placeholder="Importe" [(ngModel)]="movimientoEfectivo.importe"
              value="movimientoEfectivo.importe" class="" required numberDecimalsDirective>
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <mat-label>Comisiones</mat-label>
            <input type="text" matInput placeholder="Comisiones" [(ngModel)]="movimientoEfectivo.comisiones"
              value="movimientoEfectivo.comisiones" class="" numberDecimalsDirective>
          </mat-form-field>
        </div>

        <!-- Actividades -->
        <div class="col-4">
          <app-autocomplete-select [items]="activities" [(selectedItemId)]="movimientoEfectivo.activitiesUid"
            [idField]="'uid'" [displayField]="'name'" placeholder="Actividad">
          </app-autocomplete-select>
        </div>

        <div class="col-4">
          <app-autocomplete-select [items]="efectivoList" [(selectedItemId)]="movimientoEfectivo.efectivoId"
            [idField]="'uid'" [displayField]="'nombre'" placeholder="Cajas/Efectivo">
          </app-autocomplete-select>
        </div>

        <div class="col-4" *ngIf="isProjectEnable && projects?.length > 0">
          <app-autocomplete-select [items]="projects" [(selectedItemId)]="movimientoEfectivo.projectUid" [idField]="'id'"
            [displayField]="'display'" placeholder="Proyecto">
          </app-autocomplete-select>
        </div>

        <div class="col-4" *ngIf="isProjectEnable && expenseProjectTypes?.length > 0">
          <app-autocomplete-select [items]="expenseProjectTypes"
            [(selectedItemId)]="movimientoEfectivo.expenseProjectTypeUid" [idField]="'id'" [displayField]="'display'"
            placeholder="Tipo de proyecto de gasto"></app-autocomplete-select>
        </div>
      </div>
    </ng-container>

    <div class="delete-info delete-info--success" *ngIf="saved === true">
      <mat-icon>check_circle</mat-icon>
      <div class="delete-info__text">
        {{tittle}} {{ isEditMode === true ? 'actualizado': 'añadido' }} correctamente
      </div>
    </div>

    <ng-container *ngIf="list == true">
      <div class="dlg-empty-list">Listado</div>

      <div class="movimiento-tarjeta-credito-listado">
        <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
          [actionsTemplate]="actionsButtons">
        </app-table>
      </div>

      <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
          <ul class="custom-class">
            <li (click)="edit(uid)">
              <a>
                <mat-icon>create</mat-icon> Editar
              </a>
            </li>
            <li (click)="delete(uid)">
              <a>
                <mat-icon>warning</mat-icon> Borrar
              </a>
            </li>
          </ul>
        </ng-container>
      </ng-template>
    </ng-container>

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dlg-actions" *ngIf="saved === false">
    <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
    <button mat-flat-button class="dlg-btn-save" (click)="save()">
      <mat-icon>save</mat-icon>
      {{ isEditMode === true ? 'Actualizar' : 'Añadir'}}
    </button>
  </mat-dialog-actions>

</ng-container>
